import React from "react";
import { t } from "../../i18n";
import { FormChangeCount } from "./forms";

interface Props {
  /** Live per-form counts for the forms one assistant message touched; nothing renders when empty. */
  changes: FormChangeCount[];
  onRevertForm: (formId: string) => void;
  /** Reverts everything the message set; only offered when the message touched more than one form. */
  onRevertMessage: () => void;
}

/**
 * The "AI changed N fields in '…'" lines hung under an assistant reply, with the revert controls.
 * Counts are the bridge's live numbers, so a line goes away by itself once the admin edits,
 * saves or reverts that form.
 */
export const MessageChanges = ({ changes, onRevertForm, onRevertMessage }: Props): JSX.Element | null => {
  if (changes.length === 0) {
    return null;
  }
  return (
    <div
      className="ai-chat__changes"
      data-testid="ai-chat-changes"
    >
      {changes.map((change) => (
        <div
          key={change.formId}
          className="ai-chat__change"
        >
          {/* React escapes the text itself; i18next escaping on top would show a title's "&" as "&amp;". */}
          <span>
            {t(
              "ai-chat.forms.changed",
              { count: change.count, title: change.title, interpolation: { escapeValue: false } },
              "AI changed {{count}} fields in '{{title}}'",
            )}
          </span>
          <button
            type="button"
            className="btn btn-link ai-chat__revert"
            onClick={() => onRevertForm(change.formId)}
            data-testid="ai-chat-revert-form"
          >
            {t("ai-chat.forms.revert-all", undefined, "Revert all")}
          </button>
        </div>
      ))}
      {changes.length > 1 && (
        <div className="ai-chat__change">
          <button
            type="button"
            className="btn btn-link ai-chat__revert"
            onClick={onRevertMessage}
            data-testid="ai-chat-revert-message"
          >
            {t("ai-chat.forms.revert-message", undefined, "Revert")}
          </button>
        </div>
      )}
    </div>
  );
};
